import { render, staticRenderFns } from "./PhoneBinding.vue?vue&type=template&id=e16142a6&scoped=true&"
import script from "./PhoneBinding.vue?vue&type=script&lang=js&"
export * from "./PhoneBinding.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBinding.vue?vue&type=style&index=0&id=e16142a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16142a6",
  null
  
)

export default component.exports